/**
 * Input formatters. Their job is to make sure the Queens receive REAL, readable data
 * instead of whatever a customer types in a hurry.
 */

/** "120000" → "120,000". Strips anything that is not a digit. */
export function formatThousands(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  if (!digits) return ''
  return Number(digits).toLocaleString('en-US')
}

/**
 * Uppercases and keeps only valid VIN characters.
 * Real VINs never contain I, O, or Q — they are excluded on purpose so a typo
 * cannot reach the dealership as a dead serial number. Hard-capped at 17.
 */
export function sanitizeVin(raw: string): string {
  return raw
    .toUpperCase()
    .replace(/[^A-HJ-NPR-Z0-9]/g, '')
    .slice(0, 17)
}

/** Digits plus a single decimal point, for a rate field. */
export function sanitizeRate(raw: string): string {
  const cleaned = raw.replace(/[^\d.]/g, '')
  const [whole, ...rest] = cleaned.split('.')
  return rest.length ? `${whole}.${rest.join('').slice(0, 2)}` : whole
}
